export default {
  setMutualFundProducts(state, val) {
    state.mutualFundProducts = val;
  },
  setMutualFundVideos(state, val) {
    state.mutualFundVideos = val;
  },
  setMutualFundArticles(state, val) {
    state.mutualFundArticles = val;
  },
  setMutualFundTestimonies(state, val) {
    state.mutualFundTestimonies = val;
  },
};
